/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Increase_Playback_SpeedInputs */

const en_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase Playback Speed`)
};

const fr_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter la vitesse de lecture`)
};

const de_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergabegeschwindigkeit erhöhen`)
};

const it_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentare la velocità di riproduzione`)
};

const ru_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте скорость воспроизведения`)
};

const es_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar la velocidad de reproducción`)
};

const zh_cn2_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提高播放速度`)
};

const ja_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生速度を上げる`)
};

const hi_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेबैक गति बढ़ाएँ`)
};

const pt_pt2_shortcut_keys_name_increase_playback_speed = /** @type {(inputs: Shortcut_Keys_Name_Increase_Playback_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar a velocidade de reprodução`)
};

/**
* | output |
* | --- |
* | "Increase Playback Speed" |
*
* @param {Shortcut_Keys_Name_Increase_Playback_SpeedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_increase_playback_speed = /** @type {((inputs?: Shortcut_Keys_Name_Increase_Playback_SpeedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Increase_Playback_SpeedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "de") return de_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "it") return it_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "es") return es_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_increase_playback_speed(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_increase_playback_speed(inputs)
	return en_shortcut_keys_name_increase_playback_speed(inputs)
});